/*
 * zootii-pdp-pilot.js  (A-030 / E-044, 2026-10-13)
 * Loaded ONLY by templates/product.optimisedpdp-pilot.json (custom_liquid block "zp_pilot").
 * 1. Name field: live x/20 counter, "Printed as" spelling confirmation, emojis and symbols
 *    removed as you type (the print helper already says they are not allowed).
 *    Empty / spaces-only blocking stays with assets/pdp-personalisation.js (sitewide gate).
 * 2. Sticky mobile bar (<750px) with price + Add to cart once the real button scrolls away.
 *    It clicks the real button, so the name gate and Razorpay/Dawn logic run unchanged.
 * 3. After add: Dawn's cart notification stays; confetti is off (window.ZP_NO_CELEBRATE)
 *    and a free-shipping line (Rs 399 threshold) is added to the notification.
 * 4. Gallery: autoplay off (window.ZP_NO_AUTOPLAY), so the selected design's image stays.
 * No COD wording anywhere (COD stopped 13 Oct 2026).
 */
(function () {
  var FREE_SHIP = 39900; // paise
  var BOX = '.ymq-options-box[data-validate*="required"]';
  var BAD = /[^\p{L}\p{M}\p{N} .'&\-]/gu;
  function money(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }

  /* 1. name helper */
  function enhance(box) {
    if (box.dataset.zp) return;
    var f = box.querySelector('input.ymq-input-text, textarea.ymq-input-text');
    if (!f) return;
    box.dataset.zp = '1';
    var max = parseInt(f.getAttribute('maxlength'), 10) || 20;
    var help = document.createElement('div');
    help.className = 'zp-name-help';
    help.setAttribute('aria-live', 'polite');
    help.innerHTML = '<span class="zp-count">0/' + max + '</span><span class="zp-preview"></span><span class="zp-note" hidden></span>';
    f.insertAdjacentElement('afterend', help);
    var count = help.querySelector('.zp-count'), prev = help.querySelector('.zp-preview'), note = help.querySelector('.zp-note');
    function upd(e) {
      var v = f.value;
      var clean = v.replace(BAD, '');
      if (clean !== v) {
        f.value = clean;
        note.hidden = false;
        note.textContent = 'Emojis and symbols can’t be printed, so we removed them.';
        if (e && e.isTrusted) f.dispatchEvent(new Event('input', { bubbles: true }));
      } else if (e && e.type === 'input' && e.isTrusted) { note.hidden = true; }
      var t = f.value.trim();
      count.textContent = f.value.length + '/' + max;
      count.classList.toggle('zp-full', f.value.length >= max);
      prev.innerHTML = t ? 'Printed as: <b></b>. Please check the spelling.' : '';
      if (t) prev.querySelector('b').textContent = t;
    }
    f.addEventListener('input', upd);
    f.addEventListener('change', upd);
    upd();
  }
  function scan() { document.querySelectorAll(BOX).forEach(enhance); }

  /* 2. sticky mobile bar */
  function sticky() {
    var real = document.querySelector('product-form .product-form__submit');
    var price = document.querySelector('.product__info-container .price, .price');
    if (!real || document.querySelector('.zp-sticky')) return;
    var bar = document.createElement('div');
    bar.className = 'zp-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="zp-sticky__price"></div><button type="button" class="zp-sticky__btn button">Add to cart</button>';
    document.body.appendChild(bar);
    var pEl = bar.querySelector('.zp-sticky__price');
    function syncPrice() {
      var cur = price && (price.querySelector('.price-item--sale') || price.querySelector('.price-item--regular'));
      pEl.textContent = cur ? cur.textContent.trim().replace(/\s+/g, ' ') : '';
      bar.querySelector('button').disabled = !!real.disabled;
    }
    syncPrice();
    if (price) new MutationObserver(syncPrice).observe(price, { childList: true, subtree: true, characterData: true });
    new MutationObserver(syncPrice).observe(real, { attributes: true, attributeFilter: ['disabled'] });
    bar.querySelector('button').addEventListener('click', function () {
      real.scrollIntoView({ block: 'center', behavior: 'smooth' });
      real.click();
    });
    var last = 0;
    function check() {
      var r = real.getBoundingClientRect();
      var show = r.bottom < 0 && !!(real.offsetWidth || real.offsetHeight);
      if (bar.classList.contains('is-on') !== show) {
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - last > 100) { last = now; check(); }
      clearTimeout(check.t); check.t = setTimeout(check, 120);
    }, { passive: true });
    check();
  }

  /* 3. free-shipping line in the cart notification */
  function shipLine() {
    var host = document.querySelector('#cart-notification .cart-notification__links, #cart-notification');
    if (!host) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var el = document.querySelector('.zp-ship');
      if (!el) { el = document.createElement('p'); el.className = 'zp-ship'; host.insertAdjacentElement('afterbegin', el); }
      var left = FREE_SHIP - c.total_price;
      el.textContent = left > 0 ? 'Add ' + money(left) + ' more for free shipping (above ₹399).' : 'You get free shipping on this order.';
    }).catch(function () {});
  }
  function hookCart() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(shipLine, 400); });
        return;
      }
    } catch (e) {}
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-form')) setTimeout(shipLine, 1500);
    }, true);
  }

  function start() {
    hookCart();
    scan();
    sticky();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
